<template>
  <div>
    <v-layout text-xs-center wrap>
      <v-flex>
        <Title title="Mes recommandations"></Title>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 offset-sm1 sm10 offset-md1 md10 lg8 offset-lg2 xl6 offset-xl3>
        <Recommendations
          v-on:add-score="$emit('add-score',$event)"
          v-on:go-ranking="$emit('go-ranking', $event)"
          v-if="myRecommendations"
          :recommendations="adapt(myRecommendations)"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import Recommendations from '@/components/organisms/Recommendations.vue';
  import Title from '@/components/atoms/Title';

  const toUnplayedModeRecommentation = recommendation => ({
    game_id: recommendation.game_id,
    title: 'Teste un nouveau mode',
    cover: recommendation.cover,
    description: `Essaie le mode <b>${recommendation.mode_name}</b> de <b>${recommendation.game_title}</b>.`,
  });

  const toUnplayedDifficultyRecommendation = recommendation => ({
    game_id: recommendation.game_id,
    title: 'Teste une nouvelle difficulté',
    cover: recommendation.cover,
    description: `Essaie le mode <b>${recommendation.difficulty_name}</b> de <b>${recommendation.game_title}</b>.`,
  });

  const toUnplayedGameRecommendation = recommendation => ({
    game_id: recommendation.game_id,
    title: 'Teste un nouveau jeu',
    cover: recommendation.cover,
    description: `Essaie le jeu <b>${recommendation.title}</b>.`,
  });

  const toBestPotentialImprovementRecommendation = recommendation => ({
    game_id: recommendation.game_id,
    title: 'Améliore ton score',
    cover: recommendation.cover,
    description: `Réduis l'écart entre toi et <b>${recommendation.player}</b> sur <b>${
      recommendation.title
      }</b>, il y a un grand écart de points</b>.`,
  });

  const toMoveAccessibleRankRecommendation = recommendation => {
    function desc() {
      let str = `Prend la place de <b>${recommendation.player}</b> sur <b>${recommendation.title}</b>`;
      if (recommendation.mode && recommendation.difficulty) {
        str += ` dans le mode <b>${recommendation.mode}</b> et la difficulté <b>${recommendation.difficulty}</b>.`;
      } else if (recommendation.mode) {
        str += ` dans le mode <b>${recommendation.mode}</b>.`;
      } else if (recommendation.difficulty) {
        str += ` dans la difficulty <b>${recommendation.difficulty}</b>.`;
      } else {
        str += '.';
      }
      return str;
    }

    return {
      game_id: recommendation.game_id,
      title: 'Monte dans le classement',
      cover: recommendation.cover,
      description: desc(),
    };
  };

  export default {
    components: { Recommendations, Title },
    props: ['myRecommendations'],
    methods: {
      adapt(recommendations) {
        const r = [];
        if (recommendations.best_potential_improvement) {
          r.push(toBestPotentialImprovementRecommendation(recommendations.best_potential_improvement));
        }
        if (recommendations.most_accessible_rank) {
          r.push(toMoveAccessibleRankRecommendation(recommendations.most_accessible_rank));
        }
        if (recommendations.unplayed_mode) {
          r.push(toUnplayedModeRecommentation(recommendations.unplayed_mode));
        }
        if (recommendations.unplayed_difficulty) {
          r.push(toUnplayedDifficultyRecommendation(recommendations.unplayed_difficulty));
        }
        if (recommendations.unplayed_game) {
          r.push(toUnplayedGameRecommendation(recommendations.unplayed_game));
        }
        return r;
      },
    },
  };
</script>
